import { render, staticRenderFns } from "./DocumentViewDetails.vue?vue&type=template&id=35de9963&scoped=true&"
import script from "./DocumentViewDetails.vue?vue&type=script&lang=js&"
export * from "./DocumentViewDetails.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/directory.css?vue&type=style&index=0&id=35de9963&scoped=true&lang=css&"
import style1 from "./DocumentViewDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35de9963",
  null
  
)

export default component.exports